<template>
  <div class="content-wrap">
    <!-- 搜索表单 -->
    <receivableSearchForm
      @search="search"
      ref="searchRef"
      style="15%"
      class="customer-list-form searchform-style"
    ></receivableSearchForm>

    <!-- table展示区 -->
    <div style="padding: 0px 18px;" >
      <table-fixed
        :isSelect="true"
        :loading="loading"
        :tableData="tableData"
        :tableColumn="localColumns"
        :columnSettingsKey="$route.name"
        :lockedColumnKeys="['index']"
        @onSelectChange="onSelectChange"
        :pagination="pagination"
      >
        <template v-slot:toolbar>
          <div class="totalAmount">
            <label>{{ $t("receivableList.totalCost") }}</label>
            <span class="font-red-mint">
              <AmountText
                v-for="(item, index) of totalList"
                :key="index"
                :value="item.price"
                :currency="item.currency"
              />
            </span>
          </div>
        </template>
        <template v-slot:option="scope">
          <a-button @click="showAttachment(scope)" size="small">点击查看</a-button>
        </template>
      </table-fixed>
    </div>
  </div>
</template>
<script>
import receivableSearchForm from "./receivableSearchForm.vue";
import tableFixed from "./table-fixed.vue";
import { queryReceivableList } from "../../api/receivable";
import { columns } from "./receivable-list";
import { searchReqParam } from "../../utils/searchReqParam";
import AmountText from "../../components/AmountText.vue";

export default {
  name: "receivable-list",
  components: { tableFixed, receivableSearchForm, AmountText },
  data() {
    return {
      columns,
      localColumns: [],
      req: searchReqParam(),
      loading: false,
      tableData: [],
      selectedRows: [],
      pagination: {
        showSizeChanger: true,
        defaultPageSize: 10,
        pageSizeOptions: ["10", "15", "50", "100"],
        total: 0,
        current: 1,
        showTotal: (total) => this.$t("totalText", { total }),
        onChange: (page) => {
          this.pagination.current = page;
          this.req.params.page = page;
          this.pageInit();
        },
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1;
          this.req.params.page = 1;
          this.req.params.pageSize = pageSize;
          this.pageInit();
        },
      },
      total: 0,
      totalList: [],
      isActive: true,
    };
  },
  comments: {},
  watch: {
    loading: {
      handler() {
        this.isActive = !this.loading;
      },
    },
  },
  created() {},
  mounted() {
    this.pageInit();
  },
  methods: {
    initColumns() {
      this.localColumns = JSON.parse(JSON.stringify(this.columns));
    },
    handleListCost(list) {
      let newList = [];
      for (let index in list) {
        let item = list[index];
        if (index == "0") {
          newList.push({
            currency: item.currency,
            price: item.price,
          });
          continue;
        }
        let ov = newList.find((v) => v.currency == item.currency);
        if (!ov) {
          newList.push({
            currency: item.currency,
            price: item.price,
          });
          continue;
        }
        ov.price += item.price;
      }
      return newList;
    },

    handleCostName(list) {
      let obj = {};
      for (let index in list) {
        let item = list[index];

        if (!obj[item.chargeItemName]) {
          obj[item.chargeItemName] = [item];
          continue;
        }
        obj[item.chargeItemName].push(item);
      }
      return obj;
    },
    // 初始化页面
    pageInit() {
      this.loading = true;
      this.initColumns();
      this.req.params = this.$refs["searchRef"].req.params;
      queryReceivableList(this.req).then((res) => {
        let resData = JSON.parse(res.data);
        if (!resData.success || resData.code != "0") {
          this.$message.error(resData.msg);
          return;
        }
        let list = JSON.parse(res.data).data.list;
        this.pagination.total = JSON.parse(res.data).data.total;
        let tableDataWrap = [];
        let totalList = [];
        list.forEach((element) => {
          let dataEle = {};
          // 固定列数据
          dataEle.boundType = element.boundType;
          // dataEle.subTotal = element.subTotal?.toFixed(2);
          dataEle.planArrivalTime = element.planArrivalTime;
          dataEle.blNo = element.blNo;
          dataEle.containerNumber = element.containerNumber;
          dataEle.containerSize = element.containerSize;
          dataEle.portDistrict = element.portDistrict;
          dataEle.customerName = element.customerName;
          dataEle.orderCreateTime = element.orderCreateTime;
          dataEle.chargeSumInfo = element.chargeSumInfo;
          if (dataEle.chargeSumInfo && dataEle.chargeSumInfo.length) {
            for (let item of dataEle.chargeSumInfo) {
              if (!totalList.length) {
                totalList.push({
                  ...item
                });
                continue;
              }
              let ov = totalList.find((v) => v.currency == item.currency);
              // console.log(ov,'ov')
              if (!ov) {
                totalList.push({
                  currency: item.currency,
                  price: item.price,
                });
                continue;
              }
              ov.price = ov.price + item.price;
            }
          }
          let columns = element.chargeItems; //想同费用项汇总
          // let costName = this.handleListCost(columns)
          // console.log(columns, "columns");
          let itemCosts = this.handleCostName(element.chargeItems);
          columns.forEach((ele) => {
            dataEle[ele.chargeItemName] = itemCosts[ele.chargeItemName];
            let match = this.localColumns.find((el) => {
              return el.dataIndex == ele.chargeItemName;
            });
            // console.log("match ==== ", match);
            if (!match) {
              this.localColumns.push({
                title: ele.chargeItemName,
                dataIndex: ele.chargeItemName,
                width: "120px",
                align: "center",
                scopedSlots: { customRender: "costTem" },
              });
            }
          });
          tableDataWrap.push(dataEle);
        });
        this.tableData = tableDataWrap;
        this.totalList = totalList;
        this.tableData.forEach((element, index) => {
          element["index"] =
            index + 1 + (this.req.params.page - 1) * this.req.params.pageSize;
        });
        this.loading = false;
        // this.containerId = this.tableData.containerId;
      });
    },
    // 表单搜索
    search(data) {
      this.req.params = data.params;
      this.pagination.onChange(1);
    },
    onSelectChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    success(msg) {
      console.log(msg);
      this.pageInit();
    },
  },
};
</script>

<style lang="less" scoped>
// table样式
.content-wrap {
  overflow: auto;
  width: 100%;
  height: 100%;
}
// /deep/ .ant-table-body {
// 	max-height: 90% !important;
// }
.searchform-style {
  position: sticky;
  left: 0;
  padding: 24px 24px 0 24px;
  z-index: 101;
}
.totalAmount {
  word-break: break-all;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 26px;
  .font-red-mint {
    color: #e43a45 !important;
    font-weight: 700 !important;
  }
}
</style>
